/* ================================================================
   uf-rapido.js — botón "Agregar" de las tarjetas de producto: abre una ventana centrada
   para elegir combo y talla y agrega al carrito sin entrar a la ficha.
   Lo usan: playeras sueltas de la home, "Combínalo con", las colecciones UF y la grilla de
   búsqueda y colecciones de Impulse. Se carga en todas las páginas desde sections/uf-estilos.liquid.

   Marcado (snippets/uf-rapido.liquid):
     <div class="uf-rapido" data-uf-rapido='{"n":"Pack x3…","img":"…","url":"…",
          "v":[{"id":1,"t":"Chico","a":true,"p":47900},…]}'>
       <button type="button" class="uf-rapido__btn" data-uf-rapido-btn>…</button>
     </div>
   Packs: "g":[{"n":"Variedad","img":"…","v":[…]},{"n":"Todo Negro","img":"…","v":[…]}] en lugar de "v";
   la foto de la ventana cambia con el combo elegido.
   Si faltan nombre, foto o precio, se toman de la tarjeta (las sueltas de la home las arma JS).
   Con una sola variante agrega directo. Abre el carrito lateral de Impulse ('ajaxProduct:added');
   si la tienda usa carrito de página, va a /cart.
   ================================================================ */
(function(){
'use strict';

const raizTienda = () => (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
const pesos = c => '$' + Math.round(c / 100).toLocaleString('es-MX');
const esc = s => String(s == null ? '' : s).replace(/[&<>"]/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' })[c]);
function tallaGuardada(){ try { return localStorage.getItem('uf-talla'); } catch(e){ return null; } }
function guardarTalla(t){ try { if (['Chico','Mediano','Grande','Extra Grande'].includes(t)) localStorage.setItem('uf-talla', t); } catch(e){} }

function datos(caja){
  let d = {};
  try { d = JSON.parse(caja.dataset.ufRapido); } catch(e){}
  /* Lo que falte sale de la tarjeta */
  const card = caja.closest('.color-card, .prod, .combina__item, .grid-product, .grid__item');
  if (card){
    const img = card.querySelector('img');
    const nom = card.querySelector('.color-card__nom, .prod__nom, .combina__nom, .grid-product__title');
    const pre = card.querySelector('.color-card__sub, .prod__pre, .combina__pre, .grid-product__price');
    const link = card.querySelector('a[href]');
    if (!d.img && img) d.img = img.currentSrc || img.src;
    if (!d.n && nom){
      const t = nom.textContent.trim();                      /* las sueltas de la home: "Negro" → "Playera Negra" */
      d.n = card.classList.contains('color-card') ? 'Playera ' + ({ Negro:'Negra', Blanco:'Blanca' }[t] || t) : t;
    }
    if (!d.precio && pre) d.precio = pre.textContent.trim().split('·')[0].trim();
    if (!d.url && link) d.url = link.getAttribute('href');
  }
  d.g = d.g || [{ n:'', v:d.v || [] }];
  return d;
}

async function agregar(id){
  const r = await fetch(raizTienda() + 'cart/add.js', {
    method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
    body: JSON.stringify({ items:[{ id, quantity:1 }] }),
  });
  const data = await r.json();
  if (!r.ok) throw new Error(data.description || data.message || 'No se pudo agregar');
  return data;
}
function abrirCarrito(data){
  const tipo = window.theme && theme.settings && theme.settings.cartType;
  if (tipo === 'drawer') document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail:{ product:data.items ? data.items[0] : data }, bubbles:true }));
  else location.href = raizTienda() + 'cart';
}

/* ------------------------------ Ventana ------------------------------ */
let M = null;          // { el, d, grupo, talla, origen }

function cerrar(){
  if (!M) return;
  const { el, origen } = M;
  el.classList.remove('is-visible');
  document.documentElement.classList.remove('uf-modal-abierto');
  setTimeout(() => el.remove(), 200);
  M = null;
  if (origen) origen.focus({ preventScroll:true });
}

function pintar(){
  const { el, d } = M;
  const g = d.g[M.grupo];
  const v = g.v.find(x => x.t === M.talla && x.a);
  $$('[data-grupo]', el).forEach(b => b.setAttribute('aria-pressed', String(+b.dataset.grupo === M.grupo)));
  const ops = el.querySelector('[data-tallas]');
  ops.innerHTML = g.v.map(x => `<button type="button" class="uf-modal__op" data-talla="${esc(x.t)}" aria-pressed="${x.t === M.talla && x.a}"${x.a ? '' : ' disabled'}>${esc(x.t)}${x.a ? '' : ' <span>agotada</span>'}</button>`).join('');
  const precio = v && v.p ? pesos(v.p) : (g.v[0] && g.v[0].p ? pesos(g.v[0].p) : (d.precio || ''));
  el.querySelector('[data-precio]').textContent = precio;
  const foto = el.querySelector('.uf-modal__prod img');          /* cada combo con su foto */
  if (foto && (g.img || d.img) && foto.getAttribute('src') !== (g.img || d.img)) foto.src = g.img || d.img;
  const btn = el.querySelector('[data-agregar]');
  btn.disabled = !v;
  btn.textContent = v ? `Agregar al carrito${precio ? ' — ' + precio : ''}` : 'Elige tu talla';
}

function abrir(caja, origen){
  const d = datos(caja);
  const todas = d.g.flatMap(g => g.v);
  if (!todas.length) return;
  if (todas.length === 1){
    if (todas[0].a) agregar(todas[0].id).then(abrirCarrito).catch(e => alert(e.message));
    return;
  }
  cerrar();
  d.g.forEach(g => { if (g.img){ const i = new Image(); i.src = g.img; } });   /* el cambio de foto por combo es inmediato */
  const guardada = tallaGuardada();
  const el = document.createElement('div');
  el.className = 'uf-modal';
  el.innerHTML = `
    <div class="uf-modal__velo" data-cerrar></div>
    <div class="uf-modal__caja" role="dialog" aria-modal="true" aria-labelledby="uf-modal-t">
      <button type="button" class="uf-modal__x" data-cerrar aria-label="Cerrar">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
      </button>
      <div class="uf-modal__prod">
        ${d.img ? `<img src="${esc(d.img)}" alt="" width="96" height="96">` : ''}
        <div>
          <p class="uf-modal__t" id="uf-modal-t">${esc(d.n)}</p>
          <p class="uf-modal__precio" data-precio></p>
        </div>
      </div>
      ${d.g.length > 1 ? `
        <p class="uf-modal__lbl">Combo</p>
        <div class="uf-modal__ops">${d.g.map((g, i) => `<button type="button" class="uf-modal__op" data-grupo="${i}" aria-pressed="false">${esc(g.n)}</button>`).join('')}</div>` : ''}
      <p class="uf-modal__lbl">Talla</p>
      <div class="uf-modal__ops uf-modal__ops--tallas" data-tallas></div>
      <button type="button" class="uf-modal__agregar" data-agregar disabled>Elige tu talla</button>
      <p class="uf-modal__aviso" role="alert" data-aviso></p>
      ${d.url ? `<a class="uf-modal__ficha" href="${esc(d.url)}">Ver detalles del producto</a>` : ''}
    </div>`;
  document.body.appendChild(el);
  M = { el, d, grupo:0, talla:null, origen };
  const disp = d.g[0].v.find(x => x.t === guardada && x.a);
  if (disp) M.talla = guardada;
  pintar();
  document.documentElement.classList.add('uf-modal-abierto');
  requestAnimationFrame(() => el.classList.add('is-visible'));
  const foco = el.querySelector('.uf-modal__ops--tallas [aria-pressed="true"]') || el.querySelector('.uf-modal__ops--tallas .uf-modal__op:not([disabled])');
  if (foco) foco.focus({ preventScroll:true });

  el.addEventListener('click', async e => {
    if (e.target.closest('[data-cerrar]')) return cerrar();
    const g = e.target.closest('[data-grupo]');
    if (g){ M.grupo = +g.dataset.grupo; if (!d.g[M.grupo].v.find(x => x.t === M.talla && x.a)) M.talla = null; return pintar(); }
    const t = e.target.closest('[data-talla]');
    if (t && !t.disabled){ M.talla = t.dataset.talla; guardarTalla(M.talla); return pintar(); }
    const b = e.target.closest('[data-agregar]');
    if (b && !b.disabled){
      const v = d.g[M.grupo].v.find(x => x.t === M.talla);
      const aviso = el.querySelector('[data-aviso]');
      b.disabled = true; b.textContent = 'Agregando…'; aviso.textContent = '';
      try { const data = await agregar(v.id); cerrar(); abrirCarrito(data); }
      catch (err){ aviso.textContent = err.message; pintar(); }
    }
  });
}

function $$(s, r){ return [...r.querySelectorAll(s)]; }

document.addEventListener('click', e => {
  const btn = e.target.closest('[data-uf-rapido-btn]');
  if (!btn) return;
  e.preventDefault(); e.stopPropagation();
  abrir(btn.closest('[data-uf-rapido]'), btn);
});
document.addEventListener('keydown', e => {
  if (!M) return;
  if (e.key === 'Escape') return cerrar();
  if (e.key === 'Tab'){                       /* el foco no sale de la ventana */
    const f = $$('button:not([disabled]), a[href]', M.el.querySelector('.uf-modal__caja'));
    if (!f.length) return;
    const i = f.indexOf(document.activeElement);
    if (e.shiftKey && i <= 0){ e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && i === f.length - 1){ e.preventDefault(); f[0].focus(); }
  }
});
})();
